<template>
  <span
    :style="{
      height: computedHeight,
      width: computedWidth,
      borderRadius: borderRadius,
    }"
    class="base-skeleton"
  />
</template>

<script>
export default {
  name: 'BaseSkeleton',
  props: {
    maxWidth: {
      // The default maximum width is 100%.
      default: 100,
      type: Number,
    },
    minWidth: {
      // Lines have a minimum width of 80%.
      default: 80,
      type: Number,
    },
    height: {
      // Make lines the same height as text.
      default: '1em',
      type: String,
    },
    width: {
      // Make it possible to define a fixed
      // width instead of using a random one.
      default: null,
      type: String,
    },
    borderRadius: {
      default: '0',
      type: String,
    },
  },
  computed: {
    computedWidth() {
      // Either use the given fixed width or
      // a random width between the given min
      // and max values.
      return (
        this.width ||
        `${Math.floor(
          Math.random() * (this.maxWidth - this.minWidth) + this.minWidth
        )}%`
      )
    },
    computedHeight() {
      return this.height
    },
  },
}
</script>

<style scoped lang="scss">
.base-skeleton {
  display: inline-block;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  background-color: var(--text-1);
  opacity: 10%;
  z-index: 0;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    filter: invert(1);
    background-image: linear-gradient(
      90deg,
      rgba(#fff, 0) 0,
      rgba(#fff, 0.2) 20%,
      rgba(#fff, 0.5) 60%,
      rgba(#fff, 0)
    );
    animation: shimmer 1s infinite;
    content: '';

    @keyframes shimmer {
      100% {
        transform: translateX(100%);
      }
    }
  }
}
</style>
